module.exports = __webpack_public_path__ + "static/img/type6.0d2ff979.jpg";